import type { TersaImageModel } from '../../types';
import { nanoBananaModels } from './nano-banana';
import { imagenModels } from './imagen';

export const googleModels: Record<string, TersaImageModel> = {
    ...nanoBananaModels,
    ...imagenModels,
};